interface BrandMarkProps {
  compact?: boolean;
}

/** Shared desktop/PWA wordmark. The source artwork is maintained in UI/Assets. */
export function BrandMark({ compact = false }: BrandMarkProps) {
  return (
    <span className={`brand-mark ${compact ? 'brand-mark--compact' : ''}`} aria-label="KorsaApp">
      <span className="brand-mark__monogram" aria-hidden="true">K</span>
      {!compact && <img className="brand-mark__wordmark" src="/brand/korsa-mark.png" alt="" />}
    </span>
  );
}
